import React, { useState } from "react";
// import Checkbox from "../Checkbox";
// import toDisplayCase from "../toDisplayCase";
import { Checkbox, toDisplayCase } from "../../nq-component";

function Head({
  selectable,
  fields,
  excludeFields,
  actionsList,
  selected,
  onSelectAll,
  objects,
  selectableObjects,
  numbering,
  onSort,
}) {
  const objectsForSelectAll = selectableObjects ?? objects;
  let isFirstVisible = true;

  const [sortState, setSortState] = useState({
    field: null,
    direction: "asc",
  });

  function handleSortClick(type, field) {
    let newDirection = "asc";
    if (sortState.field === field) {
      newDirection = sortState.direction === "asc" ? "desc" : "asc";
    }

    if (typeof onSort === "function") {
      setSortState({ field, direction: newDirection });
      onSort(type, field, newDirection);
    }
  }

  return (
    <tr className="text-center bg-primary">
      {selectable && (
        <th
          className="bg-primary"
          style={{
            color: "white",
            borderRadius: "10px 0 0 0",
          }}
        >
          <Checkbox
            className="align-middle"
            id="check_all"
            checked={
              objectsForSelectAll.length === selected.length &&
              objectsForSelectAll.length !== 0
            }
            onChange={(checked) => onSelectAll(checked)}
          />
        </th>
      )}

      {numbering || numbering === 0 ? (
        <th
          className="p-3 bg-primary"
          style={{
            backgroundColor: "#283754",
            color: "white",
            borderRadius: `${!selectable ? "10px 0 0 0" : "0"}`,
          }}
        >
          #
        </th>
      ) : (
        ""
      )}

      {Object.keys(fields).map((field) => {
        const { type, ...options } = fields[field];
        if (excludeFields.includes(field)) return null;
        const label = options.label || toDisplayCase(field);
        const isFirst = isFirstVisible;
        isFirstVisible = false;

        const isSorted = sortState.field === field;
        const iconClass = isSorted
          ? sortState.direction === "asc"
            ? "bi bi-sort-down-alt"
            : "bi bi-sort-up"
          : "";
        return (
          <th
            key={field}
            onClick={() => handleSortClick(type, field)}
            className="fs-xs align-middle text-nowrap p-3 bg-primary"
            style={{
              backgroundColor: "#283754",
              color: "white",
              cursor: "pointer",
              borderRadius:
                isFirst && !selectable && !numbering && numbering != 0
                  ? "10px 0 0 0"
                  : "",
            }}
          >
            <span>
              {label} <i className={iconClass}></i>
            </span>
          </th>
        );
      })}

      {actionsList.length > 0 && (
        <>
          <th
            style={{
              borderRadius: "10px",
            }}
            className="bg-primary"
          >
            <div style={{ width: "50px" }}></div>
          </th>
          <th
            className="fs-xs align-middle text-nowrap bg-primary"
            colSpan={actionsList.length}
            style={{ borderRadius: "10px" }}
          >
            ACTIONS
          </th>
        </>
      )}

      <th
        className="fs-xs align-middle text-nowrap bg-primary"
        style={{
          backgroundColor: "#283754",
          color: "white",
          borderRadius: "0px 10px 0px 0px",
        }}
        colSpan={actionsList.length}
      >
        {objects[0]?.roles?.[0]?.name ? "Role" : null}
      </th>
    </tr>
  );
}

export default Head;
